<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>
    <app-navbar-horizontal-layout-brand />

    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <a href="http://old-phd.mininnovation.uz/"> {{ $t('Old version of the site') }} </a>
      <dark-toggler />
      <locale />
      <user-dropdown v-if="isUserLoggedIn" />
      <li
        v-else
        class="nav-item"
      >
        <b-link
          class="nav-link"
          :to="{ name: 'auth-login'}"
        >
          {{ $t('Login') }}
        </b-link>
      </li>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import darkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Locale from '../components/app-navbar/components/Locale.vue'
import UserDropdown from '@/layouts/components/app-navbar/components/UserDropdown.vue'
import { isUserLoggedIn } from '@/auth/utils'
import navMenuItems from '@/navigation/horizontal'
import AppNavbarHorizontalLayoutBrand from './AppNavbarHorizontalLayoutBrand.vue'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    Locale,
    darkToggler,
    UserDropdown,
    AppNavbarHorizontalLayoutBrand,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    return {
      isUserLoggedIn: isUserLoggedIn(),
      navMenuItems,
    }
  },
}
</script>
<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
.dropdown-user-link:after, .dropdown-language a:after {
  width: 0;
}
</style>
